import videojs from 'video.js';

// @ts-expect-error TSMIGRATION
import controlsTemplate from 'bundles/videojs/layout/controls.html';

const KEY_ESCAPE = 27;
const KEY_TAB = 9;

class SubtitlesMenuItem extends videojs.getComponent('TextTrackMenuItem') {
  createEl(type: $TSFixMe, props: $TSFixMe) {
    const ClickableComponent = videojs.getComponent('ClickableComponent');
    const el = ClickableComponent.prototype.createEl.call(
      this,
      'li',
      Object.assign(
        {
          className: 'vjs-menu-item',
          innerHTML: controlsTemplate({
            controlName: 'subtitlesMenuItem',
            label: this.options_.label,
          }),
        },
        props
      )
    );

    el.setAttribute('data-js', 'c-subtitles-menu-item');
    return el;
  }

  closeAndFocus() {
    const { player_ } = this;
    const { subtitlesMenuButton } = player_.controlBar;
    subtitlesMenuButton.menu.unlockShowing();
    subtitlesMenuButton.el().focus();
    subtitlesMenuButton.el().classList.remove('selected');
  }

  handleKeyPress(e: KeyboardEvent) {
    if (e.keyCode === KEY_ESCAPE || e.keyCode === KEY_TAB) {
      this.closeAndFocus();
      e.preventDefault();
      e.stopPropagation();
    } else {
      super.handleKeyPress(e);
    }
  }

  handleClick() {
    const { player_, options_, id_ } = this;

    // @ts-expect-error TSMIGRATION
    super.handleClick();

    player_.trigger('subtitleschange', options_.track);

    if (id_ === 'subtitles-off') {
      // hide subtitle-off if turning off subtitles
      player_.controlBar.subtitlesMenuButton.menu.hideSubtitleOffItem();
      this.closeAndFocus();
    } else {
      // show subtitle-off if turning on subtitles
      player_.controlBar.subtitlesMenuButton.menu.showSubtitleOffItem();
    }
  }
}
videojs.registerComponent('SubtitlesMenuItem', SubtitlesMenuItem);
